module.exports = __webpack_public_path__ + "img/restaurant-2.d36af38a.jpg";